import React from 'react';
import ReactDOM from 'react-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './screens/App'
import reportWebVitals from './reportWebVitals';
import './i18n';
import { getGoogleOAuthClientId } from './config/env';

// Polyfill for process.env (needed by jsPDF and other libraries)
if (typeof process === 'undefined') {
  window.process = { env: {} };
}

// Suppress Ant Design findDOMNode warning in StrictMode
// This is a known issue with Ant Design v4 and will be fixed in v5
const originalError = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('findDOMNode is deprecated')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

// Remove any blocking iframes that might be overlaying the app
const removeBlockingIframes = () => {
  // Check for iframes that might be blocking
  const allIframes = document.querySelectorAll('iframe');
  allIframes.forEach((iframe) => {
    const rect = iframe.getBoundingClientRect();
    const isFullScreen = 
      (rect.width >= window.innerWidth * 0.9 && rect.height >= window.innerHeight * 0.9) ||
      (rect.top <= 0 && rect.left <= 0 && rect.width >= window.innerWidth && rect.height >= window.innerHeight);
    
    // If iframe is covering most of the screen, hide it
    if (isFullScreen && (iframe.parentElement === document.body || iframe.parentElement === document.documentElement)) {
      iframe.style.display = 'none';
      iframe.style.pointerEvents = 'none';
      iframe.style.visibility = 'hidden';
      iframe.style.opacity = '0';
      iframe.style.zIndex = '-1';
    }
  });
};

// Run on load and periodically check
window.addEventListener('load', removeBlockingIframes);
setInterval(removeBlockingIframes, 1000);

function AppRoot() {
  const clientId = getGoogleOAuthClientId();
  const app = (
    <React.Suspense fallback="Loading...">
      <App />
    </React.Suspense>
  );
  if (!clientId) {
    return app;
  }
  return (
    <GoogleOAuthProvider clientId={clientId}>
      {app}
    </GoogleOAuthProvider>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
